import {
  GetWorkSpacesWithBookingsDocument,
  GetWorkSpacesWithBookingsQuery,
  GetWorkSpacesWithBookingsQueryVariables,
  WorkSpaceWithBookingFragment,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type WorkSpaceWithBookingNode = WorkSpaceWithBookingFragment
export type WorkSpaceWithBookingsNodes =
  GetWorkSpacesWithBookingsQuery['spaceControl']['workSpaceWithBookingsConnection']['nodes']

export const useWorkSpacesWithBookings = (variables: GetWorkSpacesWithBookingsQueryVariables) => {
  const { loading, data, refetch } = useQuery(GetWorkSpacesWithBookingsDocument, { variables })

  return {
    loading,
    workSpaces: data ? data.spaceControl.workSpaceWithBookingsConnection.nodes : [],
    refetch,
  }
}
